module.exports = "https://cdn.schoolblocks.com/assets/_next/static/media/icon_1_powerpoint_x32-9bcbf.png";